"use strict";

// when on desktop open a product on click of an overlay, on mobile (touch device) not
var touchDevice = false;
window.addEventListener('touchstart', function () {
  touchDevice = true;
}); // eslint-disable-next-line no-unused-vars

var clickOnOverlay = function clickOnOverlay(link) {
  if (!touchDevice && window.screen.width > 991) {
    window.location.href = link;
  }
};